import type {AccountLimits} from 'src/openapi/admin/models/AccountLimits';

export const DEFAULT_ACCOUNT_LIMITS: AccountLimits = {
    maxResultPerPage: 250,
    maxPagePerDay: 1000,
    maxAlertPerEmail: 25,
};

export const SEARCH_RESULTS_PER_PAGE = [5, 10, 25, 50, 100, 250];

export const ALERTS_PER_EMAIL: Array<{value: number, caption: string}> = [
    {value: 5, caption: '5'},
    {value: 10, caption: '10'},
    {value: 25, caption: '25'},
    {value: 50, caption: '50'},
    {value: 100, caption: '100'},
    {value: -1, caption: 'All'},
];

